import { clsx } from 'clsx'
import { type FC } from 'react'

import { Text, VStack, type VStackProps } from '@/components'

export interface EmptyViewProps extends VStackProps {
  title: string
  message?: string
}

export const EmptyView: FC<EmptyViewProps> = ({ children, className, title, message }) => (
  <VStack
    className={clsx(
      'pb-safe-or-4 absolute inset-x-0 inset-y-0 items-center justify-center p-4 md:justify-start',
      className
    )}
  >
    <VStack className='w-full max-w-md gap-4 p-4'>
      <Text
        accessible
        accessibilityLabel={`${title} ${message}`}
        accessibilityLiveRegion='assertive'
        accessibilityRole='alert'
        className='text-center font-poppinsSemiBold text-lg text-white'
        // @ts-ignore ts sometimes doesn't see that this is a react-native-web augment, and complains that it's not real
        tabIndex={0}
      >
        {title}
      </Text>
      {message ? (
        <Text
          accessibilityElementsHidden
          className='text-center text-white'
          importantForAccessibility='no-hide-descendants'
        >
          {message}
        </Text>
      ) : null}
      {children}
    </VStack>
  </VStack>
)
